import { render, staticRenderFns } from "./menu4.vue?vue&type=template&id=6b0b1625&scoped=true"
import script from "./menu4.vue?vue&type=script&lang=js"
export * from "./menu4.vue?vue&type=script&lang=js"
import style0 from "./menu4.vue?vue&type=style&index=0&id=6b0b1625&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0b1625",
  null
  
)

export default component.exports